import "react";
import "react/jsx-runtime";
import { b as l } from "./factory-ueRxoNOV.js";
import { r as a, a as m } from "./use-styles-DToiHEa6.js";
function u({
  classNames: t,
  styles: r,
  props: e,
  stylesCtx: s
}) {
  const o = l();
  return {
    resolvedClassNames: m({
      theme: o,
      classNames: t,
      props: e,
      stylesCtx: s || void 0
    }),
    resolvedStyles: a({
      theme: o,
      styles: r,
      props: e,
      stylesCtx: s || void 0
    })
  };
}
export {
  u
};
